import Phaser from 'phaser';

type TrayRect = { x: number; y: number; w: number; h: number };

export type TrayPanelRexBuildOptions = {
  tileW: number;
  tileH: number;
  gap: number;
  sliderH: number;
  /** Piece ids aligned with pieceTextureKeys order. */
  pieceIds: number[];
};

/**
 * Инкапсулирует создание rexUI scrollablePanel (sizer + scrollablePanel + slider).
 * Puzzle.ts не должен напрямую вызывать rexUI.add.sizer/scrollablePanel.
 */
export class TrayPanelRex {
  panel: any | null = null;
  contentSizer: any | null = null;
  trayImages: Phaser.GameObjects.Image[] = [];

  build(
    scene: Phaser.Scene,
    tr: TrayRect,
    pieceTextureKeys: string[],
    options: TrayPanelRexBuildOptions
  ): void {
    this.destroy();

    const rexUI = (scene as any).rexUI;
    if (!rexUI) {
      console.warn('rexUI plugin not found on scene (this.rexUI). Check plugin mapping.');
      return;
    }

    const { tileW, tileH, gap, sliderH, pieceIds } = options;

    const n = pieceTextureKeys.length;
    const contentWidth = n * tileW + (n - 1) * gap;
    const content = rexUI.add.sizer({
      orientation: 'x',
      space: { left: 0, right: 0, top: 0, bottom: 0, item: gap },
    });

    const trayImages: Phaser.GameObjects.Image[] = [];
    for (let i = 0; i < pieceTextureKeys.length; i++) {
      const pieceKey = pieceTextureKeys[i];
      const pieceId = pieceIds[i];
      const img = scene.add.image(0, 0, pieceKey).setOrigin(0.5, 0.5);
      img.setDisplaySize(tileW, tileH);
      img.setData('pieceId', pieceId);
      img.setData('pieceKey', pieceKey);
      img.setData('tileW', tileW);
      img.setData('tileH', tileH);
      content.add(img, 0, 'center', 0, false);
      trayImages.push(img);
    }

    content.layout();
    if (typeof (content as any).setMinSize === 'function') {
      (content as any).setMinSize(contentWidth, content.height);
    }
    content.setDepth(2000);

    const panelConfig = {
      child: content,
      mask: { padding: 0 },
    };
    const spaceConfig = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      panel: 0,
      slider: 0,
      item: 0,
    };

    const panel = rexUI.add
      .scrollablePanel({
        x: tr.x + tr.w / 2,
        y: tr.y + tr.h / 2,
        width: tr.w,
        height: tr.h,
        scrollMode: 1,
        align: { panel: 'left' },
        panel: panelConfig,
        slider: {
          endPoints: [0, 1],
          track: rexUI.add.roundRectangle(0, 0, tr.w, sliderH, 0, 0x000000, 0.25),
          thumb: rexUI.add.roundRectangle(0, 0, Math.max(40, tr.w * 0.15), sliderH, 0, 0xffffff, 0.35),
          input: 'drag',
          hideUnscrollableSlider: true,
        },
        mouseWheelScroller: {
          focus: true,
          speed: 0.6,
        },
        space: spaceConfig,
      })
      .setOrigin(0.5, 0.5)
      .setScrollFactor(0)
      .setDepth(1000)
      .layout();

    if (typeof (content as any).setMinSize === 'function') {
      (content as any).setMinSize(contentWidth, content.height);
      content.layout();
      panel.layout();
    }
    panel.scrollToLeft?.();

    this.panel = panel;
    this.contentSizer = content;
    this.trayImages = trayImages;
  }

  layout(): void {
    this.contentSizer?.layout?.();
    this.panel?.layout?.();
  }

  destroy(): void {
    if (this.panel) {
      this.panel.destroy();
      this.panel = null;
    }
    this.contentSizer = null;
    this.trayImages = [];
  }
}

